export default {
  // 标题
  title: '具身智能体集群',
  applicationScenarios: '应用场景',
  scenariosEmpty: '暂无应用场景',
  clusterEmpty: '暂无集群设备',

  // 设备分类
  categories: {
    robot: '机器人',
    dog: '机器狗',
    drone: '无人机',
    arm: '机械臂',
    hand: '灵巧手',
  },

  // 设备状态
  status: {
    online: '在线',
    offline: '离线',
    fault: '故障',
  },

  // 地名
  locations: {
    shanghaiZhangjiang: '上海张江',
    shenzhenFutian: '深圳福田',
  },

  // 设备状态描述
  deviceStates: {
    working: '作业中',
    standby: '待机',
    upgrading: '升级中',
    charging: '充电中',
    shutdown: '关机',
    maintenance: '维修中',
  },

  // 设备名称
  devices: {
    pianist: '晨昏线钢琴大师',
    h1: '宇树 通用人形机器人H1',
    x2: '智元 通用人形机器人X2',
    go2: '宇树 四足Go2',
    d1: '智元 四足D1 Ultra',
    m4td: '大疆 Matrice 4TD',
    ap3: '大疆 大疆机场3',
    termiArm: '晨昏线 TermiArm',
    luoshiArm: '珞石 xMate ER3 Pro',
    termiHand: '晨昏线 TermiHand',
    yinshiHand: '因时 xx型号',
  },

  // 场景
  scenarios: {
    piano: {
      title: '钢琴大师演奏',
      description: '多自由度机械臂、灵巧手协同演奏曲目，高精度拟人化演绎',
      tags: ['艺术表演', '指法自动生成'],
    },
    smtLoading: {
      title: '工业SMT上下料机器人',
      description: '工业机器人自动完成SMT产线物料上下料，提升产线连续作业效率与稳定性',
      tags: ['上下料自动化', '产线节拍优化'],
    },
    garmentPrinting: {
      title: '工业衣物印花',
      description: '机械臂+视觉定位实现衣物自动印花，高精度图案套印与批量化柔性生产',
      tags: ['视觉定位', '批量印花'],
    },
    c919: {
      title: '飞机驾驶舱检测',
      description: '机械臂+仿真人机交互，完成航电旋钮、开关自动化测试',
      tags: ['航空仿真', '高可靠性'],
    },
  },

  // 通用
  deviceId: 'ID',
  location: '位置',
}
